(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/helpers/common.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/helpers/common.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.common.init = function(options) {
    svs.grassroots.models.grassroots = new svs.grassroots.models.Grassroots();
    svs.grassroots.collections.grassroots = new svs.grassroots.collections.Grassroots();

    var initHandler = function() {
      svs.grassroots.router = new svs.grassroots.Router();
      Backbone.History.started ||
        Backbone.history.start({
          pushState: (options || {}).pushState,
          root: svs.core.data.baseUrl,
          hashChange: false
        });
    };

    if ((options || {}).initHandler) {
      initHandler = options.initHandler;
    }

    initHandler();
  };
})(Backbone, _, svs);


 })(window);